import { useQuery } from "@tanstack/react-query";
import { buyerReportsApi, type CostPerLeadQuery } from "@/api/buyerReports";
import { buyerReportKeys } from "./buyerReportKeys";

/** One team's board. Disabled until a team is chosen. */
export function useTeamBoard(teamId: string | null | undefined) {
  return useQuery({
    queryKey: buyerReportKeys.board(teamId ?? ""),
    queryFn: () => buyerReportsApi.board(teamId!),
    enabled: Boolean(teamId),
  });
}

/**
 * The caller's own team's board — the one-team caller's entry point, and the
 * only way the client learns which team it belongs to. `null` data means they
 * are on no team.
 */
export function useMyTeamBoard(enabled = true) {
  return useQuery({
    queryKey: buyerReportKeys.myBoard(),
    queryFn: () => buyerReportsApi.myBoard(),
    enabled,
  });
}

/** Cost per lead over a month range, narrowed server-side to what the caller
 *  may see. */
export function useCostPerLead(query: CostPerLeadQuery, enabled = true) {
  return useQuery({
    queryKey: buyerReportKeys.costPerLead(query),
    queryFn: () => buyerReportsApi.costPerLead(query),
    enabled,
  });
}
